import { useCallback } from "react";

/** A ref that sets `inert` on its node: the installed React types predate the `inert` prop. */
export const useInertRef = (isInert: boolean) =>
    useCallback(
        (node: HTMLElement | null) => {
            if (node !== null) {
                node.inert = isInert;
            }
        },
        [isInert],
    );
